import { render } from "./partsStock.vue?vue&type=template&id=238b42ad"
import script from "./partsStock.vue?vue&type=script&lang=js"
export * from "./partsStock.vue?vue&type=script&lang=js"

import exportComponent from "/container/application/releases/20260729235012/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__